<section class="productList">
  @if (productList$ | async; as productList) {
    <section class="product-page">
      @if (
        productList?.products?.length > 0 ||
        productList?.freeTextSearch?.length == 0
        ) {
        <section
          >
          <section class="header">
            <section class="content content-right">
              <section class="top" id="pagination">
                <section class="left">
                  <span>
                    <span>{{ 'plp.showing' | cxTranslate }}</span>
                    {{ pageRange }} {{ 'plp.of' | cxTranslate }}
                    {{ productList.pagination?.totalResults }}
                    {{ 'plp.products' | cxTranslate }}
                    @if (productList?.freeTextSearch?.length > 0) {
                      <span>
                        {{ 'plp.for' | cxTranslate }}
                        <span class="search-text">
                          {{ productList?.freeTextSearch }}
                        </span>
                      </span>
                    }
                  </span>
                </section>
                <span class="page-info">
                  {{ 'plp.page' | cxTranslate }} {{ currentPage }}
                  {{ 'plp.of' | cxTranslate }}
                  {{ productList.pagination?.totalPages }}
                </span>
                <cx-pagination
                  (viewPageEvent)="performPagination($event)"
                  queryParam="currentPage"
                [pagination]="this.pagination"></cx-pagination>
              </section>
              <section class="bottom">
                <section class="left">
                  @if (facets$?.length > 0) {
                    <section
                      class="facets-filter">
                      <section>
                        <cx-active-facets
                          #facetRef
                        [facet]="facet$"></cx-active-facets>
                      </section>
                      <section id="clearAll-filters">
                        <a
                          href="/dz/fr_DZ/DZD/Open-Catalogue/c/1"
                          data-di-id="di-id-37774359-a6b0cba1">
                          {{ 'plp.clearFliter' | cxTranslate }}
                        </a>
                      </section>
                    </section>
                  } @else {
                    <section
                      class="col-md-8 col-sm-7 hidden-xs js-facet-values filter-facet-none">
                      {{ 'plp.filtersApplied' | cxTranslate }} :
                      <span>{{ 'plp.none' | cxTranslate }}</span>
                    </section>
                  }
                </section>
                <section class="right">
                  <cx-sorting
                    placeHolder="Select Sort"
                    selectedOption="{{ selectedData }}"
                    [sortOptions]="productList.sorts"
                  (sortListEvent)="sortList($event)"></cx-sorting>
                </section>
              </section>
            </section>
          </section>
          <section class="main">
            <section class="content content-right">
              @for (product of productList.products; track product) {
                <app-custom-product-card
                  [product]="product"
                [iconDisplay]="true"></app-custom-product-card>
              }
            </section>
          </section>
          <section class="bottom-pagination">
            <section class="text-center showing-text">
              <span>
                {{ 'plp.showing' | cxTranslate }} {{ pageRange }}
                {{ 'plp.of' | cxTranslate }}
                {{ productList.pagination?.totalResults }}
                {{ 'plp.products' | cxTranslate }}
              </span>
            </section>
            <section class="bottom-pagination-center">
              <section class="mx-auto">
                <cx-pagination
                  (viewPageEvent)="performPagination($event)"
                  queryParam="currentPage"
                [pagination]="this.pagination"></cx-pagination>
              </section>
            </section>
            <section class="text-center">
              <span class="page-info">
                {{ 'plp.page' | cxTranslate }} {{ currentPage }}
                {{ 'plp.of' | cxTranslate }}
                {{ productList.pagination?.totalPages }}
              </span>
            </section>
          </section>
        </section>
      }
      @if (
        productList?.freeTextSearch?.length > 0 &&
        productList?.products?.length == 0
        ) {
        <section
          class="featureProdTxt"
          >
          <p
            style="display: block"
            id="noReuslt-found"
            class="bold-12"
            role="alert"
            aria-live="assertive">
            {{ 'plp.sorryNoProducts' | cxTranslate }} "{{
            productList?.freeTextSearch
            }}" {{ 'plp.noProducts' | cxTranslate }}
          </p>
        </section>
      }
    </section>
  }
</section>
